import { useEffect, useState, useRef, useCallback } from 'react';
import { SVG } from '@svgdotjs/svg.js';

import useStore from '../../store/store';
import { HeightRuler } from './common/HeightRuler';

const Source = () => {
	const gRef = useRef();
	const [gParentRef, setGParentRef] = useState({ current: undefined });

	const getSoundSourcePosition = useStore((state) => state.getSoundSourcePosition);
	const getSingleUnit = useStore(state => state.getSingleUnit);
	const singleUnit = getSingleUnit();

	const sourceHeight = useStore((state) => state.sourceHeight);
	const setSourceHeight = useStore((state) => state.setSourceHeight);

	const onHeightChange = useCallback((newHeight) => {
		setSourceHeight(newHeight);
	}, []);

	useEffect(() => {
		const draw = SVG('#main');

		const gParent = draw.group();
		setGParentRef({ current: gParent });
		const { x, y } = getSoundSourcePosition();
		gParent.transform({ translateX: x, translateY: y });
		const g = gRef.current = gParent.group();

		g.circle(10).cx(0).cy(0).fill('#ef7521');
		let boxAtDragStart;
		const sourceText = g.text('SOURCE').attr({ x: 4, y: -15 }).font({ anchor: 'middle', size: '12px' }).fill('#ffffff');
		const sourceTextSize = sourceText.node.getBBox();
		g.rect(sourceTextSize.width + 10, sourceTextSize.height + 4)
			.transform({ translate: { x: sourceTextSize.x - 5, y: sourceTextSize.y - 2 } })
			.radius(5)
			.fill('#ef7521')
			.backward();
		g
			.attr({ class: 'draggable' })
			.draggable()
			.on('dragstart', (e) => {
				boxAtDragStart = e.detail.box;
			})
			.on('dragmove', (e) => {
				e.preventDefault();
				const { box } = e.detail;
				if (Math.abs(boxAtDragStart.y2 - box.y2) > 0) {
					const newOffset = (g.transform('translateY') + (box.y2 - box.y2 % singleUnit) - 10 / 2).toFixed(1);
					setSourceHeight(newOffset > 0 ? 0 : Math.abs(newOffset * 0.1 / singleUnit).toFixed(1));
				}
			});
		return () => { setGParentRef({ current: undefined }); gParent.remove(); };
	}, [singleUnit]);

	useEffect(() => {
		gRef.current.transform({
			translateY: -sourceHeight * singleUnit / 0.1
		});
	}, [singleUnit, sourceHeight]);

	return !gParentRef.current ? null : (
		<HeightRuler
			gRef={gParentRef}
			height={sourceHeight}
			textOnLeft={true}
			onHeightChange={onHeightChange}
		/>
	);
};

export { Source };
